var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.518,
    height: 27.651,
    viewBox: "0 0 23.518 27.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1665",
    "data-name": "Group 1665",
    transform: "translate(-23.492 -104.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3246",
    "data-name": "Rectangle 3246",
    transform: "translate(23.5 104.1)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.65
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.75,
    height: 14.7,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.825,
    y: 0.825,
    width: 9.1,
    height: 13.05,
    rx: 2.175,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3247",
    "data-name": "Rectangle 3247",
    transform: "translate(36.26 117.05)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.65
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.75,
    height: 14.7,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.825,
    y: 0.825,
    width: 9.1,
    height: 13.05,
    rx: 2.175,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3248",
    "data-name": "Rectangle 3248",
    transform: "translate(36.26 104.1)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.65
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.75,
    height: 11,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.825,
    y: 0.825,
    width: 9.1,
    height: 9.35,
    rx: 2.175,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3249",
    "data-name": "Rectangle 3249",
    transform: "translate(23.492 120.75)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.65
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.75,
    height: 11,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.825,
    y: 0.825,
    width: 9.1,
    height: 9.35,
    rx: 2.175,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.e6e68721b0e94a09eb3841e954b2a9d8.svg";
export { ForwardRef as ReactComponent };